// src/utils/authClaims.js
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";

/**
 * Ensures the current ID token has activeTeamId == teamId.
 * If not, calls the callable and forces a token refresh.
 */
export async function ensureActiveTeamClaim(teamId) {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error("Not signed in");

  // If token already has the proper claim, we're good.
  const token = await user.getIdTokenResult();
  if (token.claims?.activeTeamId === teamId) return;

  // Ask backend to set the claim
  const fn = httpsCallable(getFunctions(), "setActiveTeamClaim");
  await fn({ teamId });

  // IMPORTANT: refresh token so Storage rules see the new claim
  await user.getIdToken(true);
}
